export default __webpack_public_path__ + "static/2478-53015cd6f7bdfd6920aabbf9efad65ac.jpg";